var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"oxy-align-grid-overlay",class:{
    'oxy-align-grid-overlay--hover': _vm.hover
  },style:({
    flexFlow: _vm.direction,
    justifyContent: _vm.x,
    alignItems: _vm.y
  })},[_c('div',{staticClass:"oxy-align-grid-indicator",class:{
      [`oxy-align-grid-indicator--${_vm.display}`]: true,
      [`oxy-align-grid-indicator--${_vm.direction}`]: true,
      [`oxy-align-grid-indicator--primary-axis-${_vm.x}`]: true,
      [`oxy-align-grid-indicator--cross-axis-${_vm.y}`]: true
    },style:({
      flexFlow: _vm.direction,
      alignItems: _vm.y,
      justifyContent: _vm.x
    })},[(_vm.y === 'baseline')?_c('div',{staticClass:"oxy-align-grid-indicator-baseline"},[_vm._v(" A "),_c('Icon',{attrs:{"icon":"ArrowDownIcon","size":10}})],1):[_c('span'),_c('span'),_c('span'),_c('span'),_c('span')]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }